import type { PropertyFileResponse, PropertyFileTreeNode } from '@/shared/api';
import { collectFilesDeep, findNodeByPath } from './akteBrowserNav';
import { TOP_FOLDERS } from './akteFolderMeta';

export interface AkteSummary {
  totalFiles: number;
  totalSize: number;
  occupied: number;
  lastAutoFiled: { fileName: string; uploadedAt: string } | null;
}

/** Kopfzeilen-Kennzahlen der Akte: Dateizahl, Größe, belegte Kategorien, letzte Auto-Ablage. */
export function buildAkteSummary(tree: PropertyFileTreeNode | undefined): AkteSummary {
  if (!tree) {
    return { totalFiles: 0, totalSize: 0, occupied: 0, lastAutoFiled: null };
  }

  const occupied = TOP_FOLDERS.filter(
    (m) => (findNodeByPath(tree, m.folderPath)?.descendantFileCount ?? 0) > 0,
  ).length;

  // Auto-abgelegte Ausgangs-Rechnungen liegen im Unterordner "Ausgehend" (PathBuilder).
  const ausgehend = findNodeByPath(tree, '03_Rechnungen/Ausgehend');
  const autoFiled = ausgehend ? collectFilesDeep(ausgehend) : [];
  const latestAuto = latestUploadedAt(autoFiled);

  return {
    totalFiles: tree.descendantFileCount,
    totalSize: tree.totalSizeBytes,
    occupied,
    lastAutoFiled: latestAuto
      ? {
          fileName: autoFiled.find((f) => f.uploadedAt === latestAuto)!.fileName,
          uploadedAt: latestAuto,
        }
      : null,
  };
}

/** Neuestes uploadedAt aus einer Datei-Liste (ISO-String) oder null. */
export function latestUploadedAt(files: PropertyFileResponse[]): string | null {
  let latest: string | null = null;
  for (const f of files) {
    if (latest === null || f.uploadedAt > latest) latest = f.uploadedAt;
  }
  return latest;
}
